import type { FaireProductEntity } from "../../entity_types/product";

export const p_22ftnc9s5w: FaireProductEntity = {
  token: "p_22ftnc9s5w",
  type: "product",
  name: "Lace Patchwork Short Sleeve Maxi Dress | S-XL",
  brandToken: "b_m95natja9m",
  brandName: "Aapparella",
  imageUrl:
    "https://cdn.faire.com/fastly/9f4c17acf1aa3f4de1b41a301363e9975d516016a583a52269b24dc532f0d51b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ca24598263812fd1753213e6032b11f4bdc2075ab0943682f599e9221bcf3d41.jpeg",
    "https://cdn.faire.com/fastly/39644a5d02b1cf5e816d33928bdba02529a0194e91fe30761cae063f888804a8.jpeg",
    "https://cdn.faire.com/fastly/1982b065fe51541ae232c7d28f6994f66968a3c5abc82e3892260eac0d2437fa.jpeg",
    "https://cdn.faire.com/fastly/bcf242aee01ae7cf6f845e9da9ade0a159d163b2539820c0fa676e63d24d94cf.jpeg",
    "https://cdn.faire.com/fastly/571bcb43d2f946a2d3b03257a4e21e1fbc2889bef2ec128081761c0975abdb7f.jpeg",
    "https://cdn.faire.com/fastly/aaf28b2ba4cf12d96fc097da353499c895104cfc6d28f877636e6518ec4433a7.png",
  ],
  priceDollars: 19,
  description:
    "The Dress\n🔹 Fabric |  62%Polyester+32%Cotton+6%Elastane\n🔹 Pattern | Solid\n🔹 Style | Casual\n\n👕 Size Chart-INCH\nSize\tBust\tHem  Shoulder  Sleeve\tLength\nS   \t41.7  \t56.7     \t21.5      \t7.1    \t52.8\nM  \t44.1  \t59.1     \t22.6    \t7.1    \t53.5\nL  \t46.5\t61.4     \t23.8    \t7.1    \t54.3\nXL\t49.6\t64.6    \t25.4    \t7.1    \t55.1\n\n\n📋 Tag |  Care Label per piece, pls read the size on the care label! We also offer brand tag customization service, any request pls let us know to assist you!!\n\nTo make you happy and easy shopping, we will do our absolute best to help you, any question about styles/orders, pls contact us freely!💗",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:41.570Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
